<template>
    <div class="box" :style="`background-image:url(${Welfare_47h_bg})`">
        <div v-if="is_show" class="box_mask">
            <img :src="$config.SystemOS=='IOS'?renew_tips_ios:renew_tips_android" alt="">
        </div>

        <img class="title" :src="Welfare_47h_title" alt="">
        <div class="footer_box">
            <img class="footer" :src="Welfare_47h_footer" alt="">
            <div class="button_box">
                <div @click="jump_link(1)"></div>
                <div @click="jump_link(2)"></div>
                <div @click="jump_link(2)"></div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name:'WelfareClassPay',
    data(){
        const Welfare_47h_bg = this.$OSSBaseUrl + 'Welfare_47h_bg.png';
        const Welfare_47h_title = this.$OSSBaseUrl + 'Welfare_47h_title.png';
        const Welfare_47h_footer = this.$OSSBaseUrl + 'Welfare_47h_footer.png';
        const renew_tips_ios = this.$OSSBaseUrl +'renew_tips_ios.png';
        const renew_tips_android = this.$OSSBaseUrl + 'renew_tips_android.png';
        return{
            is_show: false,
            Welfare_47h_bg,
            Welfare_47h_title,
            Welfare_47h_footer,
            renew_tips_ios,
            renew_tips_android,
        }
    },
    mounted(){
        let data = {
            page_from:'main_page',
            page_name:'WelfareClassPay',
            page_time:'0.00',
            receiver_id: '',
            page_param:{dayhour:this.$route.query.dayhour},
        };
        this.$store.dispatch('Public/inH5Record', data)
    },
    methods:{
        jump_link(type){
            let URL = window.location.href
            if( URL.includes('&jump_link=') ){
                let first_index = URL.indexOf('&jump_link=')
                URL = URL.substr(0,first_index)
            }
            switch (type) {
                case 1:
                    history.replaceState({},0,URL+'&jump_link=1')
                    break;
                case 2:
                    history.replaceState({},0,URL+'&jump_link=2')
                    break;
            }
            this.is_show = true
        },
    }
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>